import {
  useEffect,
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Wallets() {

  const navigate =
    useNavigate();

  const [wallets,
    setWallets] =
    useState([]);

  useEffect(() => {

    loadWallets();

  }, []);

  const loadWallets =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            "/wallets",
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setWallets(
          res.data.wallets || []
        );

      } catch (err) {

        console.log(err);

      }

    };

  const totalBalance =
    wallets.reduce(
      (sum, wallet) =>
        sum +
        Number(wallet.balance),
      0
    );

  const walletColor =
    (type) => {

      switch (type) {

        case "cash":

          return {
            border:
              "border-green-500/20",
            text:
              "text-green-400",
            bg:
              "bg-green-500/10"
          };

        case "bank":

          return {
            border:
              "border-blue-500/20",
            text:
              "text-blue-400",
            bg:
              "bg-blue-500/10"
          };

        default:

          return {
            border:
              "border-yellow-500/20",
            text:
              "text-yellow-400",
            bg:
              "bg-yellow-500/10"
          };

      }

    };

  return (

    <div>

      {/* Header */}

      <div
        className="
        flex
        justify-between
        items-center
        flex-wrap
        gap-4
        mb-8
        "
      >

        <div>

          <h1
            className="
            text-4xl
            font-bold
            "
          >
            Wallets
          </h1>

          <p
            className="
            text-gray-400
            mt-2
            "
          >
            Manage your business wallets
          </p>

        </div>

        {hasPermission("wallet.transfer") && (
          <button
            onClick={() =>
              navigate(
                "/admin/wallets/transfer"
              )
            }
            className="
          px-5
          py-3
          bg-yellow-500
          text-black
          rounded-xl
          font-semibold
          "
          >
            Transfer Money
          </button>
        )}

      </div>

      {/* Total */}

      <div
        className="
        bg-gradient-to-r
        from-yellow-500
        to-orange-500
        rounded-2xl
        p-8
        text-black
        mb-8
        "
      >

        <p
          className="
          text-lg
          "
        >
          Total Balance
        </p>

        <h2
          className="
          text-5xl
          font-bold
          mt-2
          "
        >
          ₹
          {totalBalance.toFixed(2)}
        </h2>

      </div>

      {/* Wallet Cards */}

      <div
        className="
        grid
        md:grid-cols-3
        gap-6
        "
      >

        {wallets.map(
          (wallet) => {

            const color =
              walletColor(
                wallet.wallet_type
              );

            return (

              <div
                key={wallet.id}
                className={`
                bg-[#111]
                rounded-2xl
                p-6
                border
                ${color.border}
                `}
              >

                <div
                  className="
                  flex
                  justify-between
                  items-center
                  "
                >

                  <div>

                    <h2
                      className="
                      text-2xl
                      font-bold
                      "
                    >
                      {
                        wallet.wallet_name
                      }
                    </h2>

                    <span
                      className={`
                      inline-block
                      mt-2
                      px-3
                      py-1
                      rounded-full
                      text-sm
                      capitalize
                      ${color.bg}
                      ${color.text}
                      `}
                    >
                      {
                        wallet.wallet_type
                      }
                    </span>

                  </div>

                </div>

                <div
                  className="
                  mt-8
                  "
                >

                  <p
                    className="
                    text-gray-400
                    "
                  >
                    Current Balance
                  </p>

                  <h2
                    className={`
                    text-4xl
                    font-bold
                    mt-2
                    ${color.text}
                    `}
                  >
                    ₹
                    {Number(
                      wallet.balance
                    ).toFixed(2)}
                  </h2>

                </div>

                <div
                  className="
                  grid
                  grid-cols-2
                  gap-3
                  mt-8
                  "
                >

                  {hasPermission("wallet.add") && (
                    <button
                      onClick={() =>
                        navigate(
                          `/admin/wallets/add-money?id=${wallet.id}`
                        )
                      }
                      className="
                    bg-green-500
                    py-3
                    rounded-xl
                    font-semibold
                    "
                    >
                      + Add
                    </button>
                  )}

                  {hasPermission("wallet.withdraw") && (
                    <button
                      onClick={() =>
                        navigate(
                          `/admin/wallets/withdraw?id=${wallet.id}`
                        )
                      }
                      className="
                    bg-red-500
                    py-3
                    rounded-xl
                    font-semibold
                    "
                    >
                      Withdraw
                    </button>
                  )}

                  {hasPermission("wallet.transfer") && (
                    <button
                      onClick={() =>
                        navigate(
                          `/admin/wallets/history/${wallet.id}`
                        )
                      }
                      className="
                    col-span-2
                    bg-blue-500
                    py-3
                    rounded-xl
                    font-semibold
                    "
                    >
                      View History
                    </button>
                  )}

                </div>

              </div>

            );

          }
        )}

      </div>

    </div>

  );

}

export default Wallets;